import { Column } from "react-table";
import { TableCustomHeader } from "../../component/table/components/TableCustomHeader";
import { TableCustomCell } from "../../component/table/components/TableCustomCell";
import { IConnect } from "../models/ConnectModels";

export const COLUMNS: ReadonlyArray<Column<IConnect>> = [
  {
    Header: (props) => (
      <TableCustomHeader<IConnect>
        tableProps={props}
        title="STT"
        className="text-center text-light spaces W-40"
      />
    ),
    id: "stt",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="text-center "
        data={props.data[props.row.index].stt}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<IConnect>
        tableProps={props}
        title="Đơn vị sử dụng"
        className="text-center text-light spaces min-w-200"
      />
    ),
    id: "orgName",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="text-center"
        data={props.data[props.row.index].orgName}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<IConnect>
        tableProps={props}
        title="Đơn vị cung cấp"
        className="text-center text-white align-middle bg-pri spaces min-w-50"
      />
    ),
    id: "orgProvideName",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="s-2"
        data={props.data[props.row.index].orgProvideName}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<IConnect>
        tableProps={props}
        title="Dịch vụ"
        className="text-center text-white align-middle bg-pri min-w-200px"
      />
    ),
    id: "serviceName",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="s-2"
        data={props.data[props.row.index].serviceName}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<IConnect>
        tableProps={props}
        title="Endpoint url"
        className="text-center text-white align-middle bg-pri spaces min-w-150"
      />
    ),
    id: "endpointUrl",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="s-2"
        data={props.data[props.row.index].endpointUrl}
      />
    ),
  },
];
